import React, { useEffect } from 'react';

import Heading from '@react/react-spectrum/Heading';
import { warning } from '@react/react-spectrum/Toast';

import { QuickSetupContextProvider } from './Context';
import General from './General';
import Presets from './Presets';
import Advanced from './Advanced';
import Actions from './Actions';

import './QuickSetup.scss';

export default function QuickSetup() {
  useLegacyWebRedirectionToast();

  return (
    <QuickSetupContextProvider value={{}}>
      <div className="quick-setup">
        <div className="header">
          <div className="title">
            <Heading size={1}>Quick Setup</Heading>
          </div>
          <Actions />
        </div>

        <div className="content">
          <section>
            <General />
          </section>
          <section>
            <Presets />
          </section>
          <section>
            <Advanced />
          </section>
        </div>
      </div>
    </QuickSetupContextProvider>
  );
}

function useLegacyWebRedirectionToast() {
  useEffect(() => {
    try {
      const params = new URLSearchParams(window.location.search);
      const isLegacyRedirect = params.get('legacy_web_redirection') === '1';
      if (isLegacyRedirect) {
        warning(
          'Legacy web projects have been decommissioned. Please create new web projects using Quick Setup instead.',
          {
            timeout: 0
          }
        );
      }
    } catch {
      // no-op
    }
  }, []);
}
